<template>
  <div class="ad-sad-content-list2">
    <template v-for="(content_program, subIndex) in contentPrograms">
      <!-- Standalone content (not in a program) -->
      <template v-if="content_program.is_program == 0">
        <div :key="'standalone_' + subIndex" class="ad-content-standalone2">
          <ul class="ad-item-list2">
            <ContentItem v-if="content_program.file_category_id"
                         :can_open_contents_in_order="canOpenContentsInOrder"
                         :certificate_id="content_program.certificate_id"
                         :contentItem="content_program"
                         :icon="content_program.file_category?.icon"
                         :is_completed="unlockedItems.includes(content_program.id)"
                         :is_locked="lockedItems.includes(content_program.id)"
                         :is_unlocked="currentItem == content_program.id"
                         :name="$t(content_program.file_category?.name)"
                         :point="content_program.point"
                         :title="content_program.title"
                         @linkClick="$emit('link-click', content_program)"
                         @show_certificate="$emit('show-certificate', content_program.id)" />
          </ul>
        </div>
      </template>

      <!-- Program with sections (accordion) -->
      <template v-else>
        <div :key="'program_' + subIndex" class="ad-content-program2">
          <div v-for="(subItem, index) in content_program.sections"
               :key="'sections_id' + subItem.id + '_index_' + subIndex + '_sub_index_' + index"
               class="ad-content-section2">
            <button class="ad-section-toggle2" :class="{ 'ad-section-toggle2--open': openSections[subIndex + '_' + index] }"
                    type="button" @click="toggleSection(subIndex + '_' + index)">
              <span class="ad-section-title2">{{ subItem.name }}</span>
              <span class="ad-section-meta2">{{ subItem.contents ? subItem.contents.length : 0 }} {{ $t('general.content') || 'içerik' }}</span>
              <i class="uil-angle-down ad-section-arrow"></i>
            </button>
            <div v-show="openSections[subIndex + '_' + index]" class="ad-section-body2">
              <ul class="ad-item-list2">
                <template v-for="(educationContent, contentIndex) in subItem.contents">
                  <ContentItem v-if="educationContent.file_category_id"
                               :key="'content_' + educationContent.id + '_' + contentIndex"
                               :can_open_contents_in_order="canOpenContentsInOrder"
                               :certificate_id="educationContent.certificate_id"
                               :contentItem="educationContent"
                               :icon="educationContent.file_category?.icon"
                               :is_completed="unlockedItems.includes(educationContent.id)"
                               :is_locked="lockedItems.includes(educationContent.id)"
                               :is_unlocked="currentItem == educationContent.id"
                               :name="$t(educationContent.file_category.key_name)"
                               :point="educationContent.point"
                               :title="educationContent.title"
                               @linkClick="$emit('link-click', educationContent)"
                               @show_certificate="$emit('show-certificate', educationContent.id)" />
                </template>
              </ul>
            </div>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import ContentItem from "@/view/components/assignmentDetail/ContentItem.vue";

export default {
  name: "ContentList",
  components: { ContentItem },
  props: {
    contentPrograms: { type: Array, default: () => [] },
    canOpenContentsInOrder: { type: Boolean, default: false },
    unlockedItems: { type: Array, default: () => [] },
    lockedItems: { type: Array, default: () => [] },
    currentItem: { type: [Number, String], default: null },
    userContentCompleted: { type: Array, default: () => [] },
  },
  emits: ['link-click', 'show-certificate'],
  data() {
    return {
      openSections: {},
    };
  },
  mounted() {
    // İlk section'ı varsayılan olarak aç
    if (this.contentPrograms) {
      this.contentPrograms.forEach((program, subIndex) => {
        if (program.is_program && program.sections) {
          program.sections.forEach((_, index) => {
            this.$set(this.openSections, subIndex + '_' + index, index === 0);
          });
        }
      });
    }
  },
  methods: {
    toggleSection(key) {
      this.$set(this.openSections, key, !this.openSections[key]);
    },
  },
};
</script>

<style scoped>
.ad-sad-content-list2 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Standalone content item wrapper */
.ad-content-standalone2 {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: visible;
}

/* Program wrapper */
.ad-content-program2 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Section (accordion group) */
.ad-content-section2 {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: visible;
  background: #fff;
}

/* Section toggle button */
.ad-section-toggle2 {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 12px 16px;
  background: #f8fafc;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s;
  gap: 10px;
  text-align: left;
}

.ad-section-toggle2:hover {
  background: #f1f5f9;
}

.ad-section-title2 {
  flex: 1;
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ad-section-meta2 {
  font-size: 12px;
  color: #94a3b8;
  font-weight: 500;
  flex-shrink: 0;
}

.ad-section-arrow {
  font-size: 18px;
  color: #94a3b8;
  flex-shrink: 0;
  transition: transform 0.2s;
}

.ad-section-toggle2--open .ad-section-arrow {
  transform: rotate(180deg);
}

/* Section body (content items) */
.ad-section-body2 {
  border-top: 1px solid #e2e8f0;
}

/* Item list (wraps ContentItem <li> elements) */
.ad-item-list2 {
  padding: 0;
  margin: 0;
  list-style: none;
}

.ad-item-list2 >>> li {
  padding: 10px 14px;
  font-size: 13px;
  border-bottom: 1px solid #f1f5f9;
  background: #fff;
  display: flex;
  align-items: center;
  overflow: visible !important;
  white-space: normal;
  max-width: none;
  position: relative;
  border-radius: 0;
}

/* Standalone: ilk ve son li köşe radius */
.ad-content-standalone2 .ad-item-list2 >>> li:first-child {
  border-radius: 8px 8px 0 0;
}

.ad-content-standalone2 .ad-item-list2 >>> li:last-child {
  border-bottom: none;
  border-radius: 0 0 8px 8px;
}

.ad-content-standalone2 .ad-item-list2 >>> li:only-child {
  border-radius: 8px;
}

/* Section body: sadece son li alt köşe radius */
.ad-section-body2 .ad-item-list2 >>> li:first-child {
  border-radius: 0;
}

.ad-section-body2 .ad-item-list2 >>> li:last-child {
  border-bottom: none;
  border-radius: 0 0 8px 8px;
}

.ad-item-list2 >>> li:last-child {
  border-bottom: none;
}

.ad-item-list2 >>> li:hover {
  background: #f8fafc;
}

/* Completed - uyumlu yeşil */
.ad-item-list2 >>> li.completed {
  background: #f0fdf4;
  border-left: 3px solid #86efac;
}

.ad-item-list2 >>> li.active {
  background: #f8fafc;
}

.ad-item-list2 >>> li .icon-cat {
  font-size: 0.65rem;
  background: #475569;
  color: #fff !important;
  padding: 4px 8px;
  border-radius: 4px;
  min-width: auto;
  margin-right: 10px;
  flex-shrink: 0;
}

.ad-item-list2 >>> li.completed .icon-cat {
  background: #16a34a;
}

.ad-item-list2 >>> li.locked .icon-cat {
  background: #cbd5e1;
}

/* Başlık - ortada, flex ile büyüsün */
.ad-item-list2 >>> li > a {
  font-size: 13px;
  color: #1e293b;
  padding: 2px 4px;
  margin-right: auto;
  flex: 1;
  min-width: 0;
}

.ad-item-list2 >>> li.locked > a {
  color: #94a3b8;
}

/* Sağ taraf (yetkinlik + puan) */
.ad-item-list2 >>> li > span {
  font-size: 12px;
  color: #64748b;
  flex-shrink: 0;
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 6px;
}

.ad-item-list2 >>> li.completed > span {
  font-weight: 600;
  color: #16a34a;
}

.ad-item-list2 >>> li .uil-check-circle {
  color: #16a34a;
}

.ad-item-list2 >>> li .uil-lock-alt {
  color: #94a3b8;
}

/* Yetkinlik dropdown - z-index fix */
.ad-item-list2 >>> li .competencies-dropdown {
  position: relative;
  z-index: 10;
}

.ad-item-list2 >>> li .competencies-list {
  z-index: 100;
}

/* Hover olan li'nin z-index'i yükselsin ki dropdown alttaki kartın üstünde kalsın */
.ad-item-list2 >>> li:hover {
  z-index: 20;
}

/* Responsive — tablet */
@media (max-width: 768px) {
  .ad-sad-content-list2 {
    gap: 6px;
  }

  .ad-section-toggle2 {
    padding: 10px 12px;
    gap: 8px;
  }

  .ad-section-title2 {
    font-size: 13px;
  }

  .ad-section-meta2 {
    font-size: 11px;
  }

  .ad-item-list2 >>> li {
    padding: 10px 12px;
    font-size: 12px;
    flex-wrap: wrap;
    gap: 6px;
  }

  .ad-item-list2 >>> li .icon-cat {
    font-size: 0.6rem;
    padding: 3px 6px;
    margin-right: 8px;
  }

  .ad-item-list2 >>> li > a {
    font-size: 12px;
    flex: 1 1 0;
    min-width: 0;
    word-break: break-word;
  }

  .ad-item-list2 >>> li > span {
    font-size: 11px;
    gap: 4px;
  }
}

/* Responsive — mobile */
@media (max-width: 480px) {
  .ad-sad-content-list2 {
    gap: 4px;
  }

  .ad-section-toggle2 {
    padding: 10px;
    gap: 6px;
  }

  .ad-section-title2 {
    font-size: 12px;
    white-space: normal;
    line-height: 1.3;
  }

  .ad-section-meta2 {
    display: none;
  }

  .ad-item-list2 >>> li {
    padding: 10px;
    flex-wrap: wrap;
    gap: 4px 8px;
  }

  .ad-item-list2 >>> li .icon-cat {
    font-size: 0.55rem;
    padding: 3px 5px;
    margin-right: 6px;
    flex-shrink: 0;
  }

  /* Başlık tam genişlik alsın */
  .ad-item-list2 >>> li > a {
    font-size: 12px;
    flex: 1 1 0;
    min-width: 0;
    word-break: break-word;
    line-height: 1.4;
  }

  /* Sağ taraf (puan + yetkinlik + kilit) alt satıra geçsin */
  .ad-item-list2 >>> li > span {
    width: 100%;
    margin-left: 0;
    justify-content: flex-end;
    font-size: 11px;
    flex-wrap: wrap;
    gap: 4px;
  }

  /* Yetkinlik dropdown mobilde küçülsün */
  .ad-item-list2 >>> li .competencies-dropdown {
    margin-left: 0;
  }
}
</style>
